<app-booking-calendar [compactView]="compactView" [hideActionBar]="hideActionBar"></app-booking-calendar>